query GetFundAccounts(
  $page: Int
  $limit: Int
  $search: String
  $adminFeeIssueFilter: Boolean
) {
  fundAccounts(
    page: $page
    limit: $limit
    search: $search
    adminFeeIssueFilter: $adminFeeIssueFilter
  ) {
    collection {
      id
      currency
      sageCode
      fund {
        id
        name
        legalEntity {
          id
          name
        }
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
